import React, { ChangeEvent } from 'react';
import { Container, SeparatorVertical } from './styles';
import { useAgendContas } from '../../hook/useAgendContas';
import {
  BuscaParceiro,
  Categoria,
  ContaBanco,
  Finalizadora,
  InputDate,
  InputMoney,
  InputNumber,
  InputRadioBox,
  InputSelect,
} from '~/components/NovosInputs';
import { Row, Col } from 'react-bootstrap';
import { tipoDtaEntrada, tiposFrequencia } from '../../types';
import moment from 'moment';

export const Fields: React.FC = () => {
  const {
    formAgendamento,
    handleChangeTipoConta,
    tipoCategoria,
    contaBancoRetriever,
    tipoConta,
    loja,
    handleChangeDtaTermino,
    handleDisableQtdParcelas,
    disabledQtdParcela,
    setContaBancoRetriever,
    handleDisabledDtaTermino,
    disabledDtaTermino,
    isUpdate,
  } = useAgendContas();
  const { register, control, errors, setValue, clearErrors, watch } =
    formAgendamento;

  const handleChangeTipoFreq = (selected: {
    value: number | string;
    label: string;
  }) => {
    setValue('tipo_frequencia', selected);
    clearErrors('tipo_frequencia');
    handleDisableQtdParcelas(false);
    handleDisabledDtaTermino(false);

    if (selected.value !== 0 && Number(watch('qtd_parcelas')) === 0) {
      handleDisabledDtaTermino(true);
    }

    if (selected.value === 0) {
      handleDisableQtdParcelas(true);
    }
    handleChangeDtaTermino();
  };

  return (
    <Container>
      <Row className="mt-3">
        <Col sm={12} md={3} style={{ marginTop: '6px' }}>
          <span className="label">Tipo:</span>
          <InputRadioBox
            style={{ marginTop: '1px' }}
            name="tipo_conta"
            qtdButtons={2}
            defaultValue={0}
            value={tipoConta.value}
            disabled={isUpdate}
            options={[
              {
                value: 0,
                label: 'Pagamento',
                id: 'pgto',
              },
              {
                value: 1,
                label: 'Recebimento',
                id: 'receb',
              },
            ]}
            onChange={(value: any) => {
              const items = ['pgto', 'receb'];
              handleChangeTipoConta({ value, label: items[value] });
              setValue('cod_categoria', '');
            }}
          />
        </Col>
        <Col sm={12} md={4}>
          <InputSelect
            label="Frequência *"
            name="tipo_frequencia"
            placeholder="Selecione..."
            register={register}
            control={control}
            isError={!!errors.tipo_frequencia}
            options={tiposFrequencia}
            changeSelected={(selected) => {
              handleChangeTipoFreq(selected);
            }}
          />
        </Col>
        <Col sm={12} md={5}>
          <BuscaParceiro
            label="Parceiro *"
            placeholder="Selecione..."
            name="cod_pessoa"
            disabled={false}
            register={register}
            isError={!!errors.cod_pessoa}
            control={control}
            customOptions={{
              buscarPor: { cliente: true, fornecedor: true, loja: true },
            }}
            changeSelected={(selected: any) => {
              clearErrors('cod_pessoa');
              const cod = selected.cod_pessoa ? selected.cod_pessoa : '';
              const nome = selected.nome_pessoa ? selected.nome_pessoa : '';
              const cidade = selected.des_cidade
                ? ` (${selected.des_cidade} - ${selected.des_uf})`
                : '';
              setValue('cod_pessoa', {
                value: selected.value,
                label: `${cod} - ${nome} ${cidade}`,
              });
            }}
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col sm={12} md={2}>
          <InputDate
            label="1° Vencimento *"
            name="dta_docto"
            control={control}
            register={register}
            isError={!!errors.dta_docto}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              clearErrors('dta_docto');
              setValue(
                'dta_docto',
                moment(e.target.value).format('YYYY-MM-DD'),
              );
              handleChangeDtaTermino();
            }}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputMoney
            label="Valor Parcela *"
            name="val_docto"
            placeholder="0,00"
            min={0}
            max={9999999}
            maxLength={15}
            control={control}
            register={register}
            isError={!!errors.val_docto}
            onInput={(e: ChangeEvent<HTMLInputElement>) => {
              const { value } = e.target;
              clearErrors('val_docto');
              setValue('val_docto', value);
            }}
          />
        </Col>
        <Col sm={12} md={3}>
          <InputSelect
            label="Data da Entrada *"
            name="tipo_dta_entrada"
            placeholder="Selecione..."
            register={register}
            control={control}
            isError={!!errors.tipo_dta_entrada}
            options={tipoDtaEntrada}
            changeSelected={(selected) => {
              clearErrors('tipo_dta_entrada');
              setValue('tipo_dta_entrada', selected);
            }}
          />
        </Col>
        <Col sm={12} md={1} style={{ width: '110px' }}>
          <InputNumber
            label="Dia"
            name="num_dia_entrada"
            step="1"
            min={1}
            max={31}
            maxLength={2}
            placeholder="1"
            register={register}
            control={control}
            isError={!!errors.num_dia_entrada}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              const val = e.target.value;
              if (Number(val) < 1) {
                setValue('num_dia_entrada', 1);
              }
              if (Number(val) <= 31 && val.length <= 2) {
                return setValue('num_dia_entrada', val);
              }
            }}
          />
        </Col>
        <Col md={1} style={{ width: '40px' }}>
          <SeparatorVertical />
        </Col>
        <Col sm={12} md={2} style={{ width: '150px' }}>
          <InputNumber
            label="Qtd. Parcelas"
            name="qtd_parcelas"
            step="1"
            min={0}
            max={999}
            maxLength={3}
            placeholder="0"
            register={register}
            control={control}
            allowsComma={false}
            allowNegativeValue={false}
            disabled={disabledQtdParcela}
            isError={!!errors.qtd_parcelas}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              let { value } = e.target;
              if (value.includes('-')) {
                value = value.replace('-', '');
              }
              if (Number(value) === 0) {
                handleDisabledDtaTermino(true);
                return setValue('qtd_parcelas', value);
              }
              handleDisabledDtaTermino(false);
              setValue('qtd_parcelas', value);
              handleChangeDtaTermino();
            }}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputDate
            label="Dta. do Término"
            name="dta_termino"
            control={control}
            register={register}
            disabled={disabledDtaTermino}
            isError={!!errors.dta_termino}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              clearErrors('dta_termino');
              setValue(
                'dta_termino',
                moment(e.target.value).format('YYYY-MM-DD'),
              );
            }}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col sm={12} md={4}>
          <ContaBanco
            label="Conta *"
            placeholder="Selecione..."
            control={control}
            isError={!!errors.cod_cc}
            retriever={contaBancoRetriever}
            allowNone={false}
            loja={loja.cod_loja}
            register={register}
            name="cod_cc"
            changeSelected={(selected) => {
              clearErrors('cod_cc');
              setValue('cod_cc', selected, {
                shouldDirty: true,
                shouldValidate: true,
              });

              setContaBancoRetriever(null);
            }}
          />
        </Col>
        <Col sm={12} md={4}>
          <Finalizadora
            label="Finalizadora *"
            placeholder="Selecione..."
            control={control}
            isError={!!errors.cod_finalizadora}
            loja={loja.cod_loja}
            register={register}
            name="cod_finalizadora"
            changeSelected={(selected) => {
              clearErrors('cod_finalizadora');
              setValue('cod_finalizadora', selected);
            }}
          />
        </Col>
        <Col sm={12} md={4}>
          <Categoria
            label="Categoria *"
            placeholder="Selecione..."
            control={control}
            ListaWidth="480px"
            tipoCategoria={tipoCategoria}
            isError={!!errors.cod_categoria}
            register={register}
            hideNoneOption
            name="cod_categoria"
            changeSelected={(selected) => {
              clearErrors('cod_categoria');
              setValue('cod_categoria', selected);
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};
